import {
  call,
  put,
  takeEvery,
  all,
  fork,
} from 'redux-saga/effects';
import { setMonitorErrors, TYPES } from './actions';

import { createActivityProduction } from '../../services';

const useFixtures = process.env.USE_FIXTURES;

export function* callSaveActivityProduction({ payload, completion }) {
  try {
    const productionId = useFixtures
      ? null
      : yield call(createActivityProduction, payload);
    if (completion?.resolve) {
      completion.resolve(productionId);
    }
  } catch (error) {
    yield put(setMonitorErrors(error.message));
    if (completion?.reject) {
      completion.reject(error);
    }
  }
}

function* watchCallSaveActivityProduction() {
  yield takeEvery(TYPES.SAVE_ACTIVITY_PRODUCTION, callSaveActivityProduction);
}

export default function* practiceMonitorHandlerSaga() {
  yield all([
    fork(watchCallSaveActivityProduction),
  ]);
}
